// extracted by mini-css-extract-plugin
export default {"order_details":"OrderDetailsPage_order_details__PIhSa","order_items":"OrderDetailsPage_order_items__ROqRP","loader_position":"OrderDetailsPage_loader_position__muWvb"};